// --- Helper Functions ---
function toRad(deg) {
  return deg * (Math.PI / 180);
}

async function getLatLon(zip) {
  console.log(`[getLatLon] Fetching lat/lon for ZIP: ${zip}`);
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=json&postalcode=${zip}&country=us&limit=1`;
    const response = await fetch(url, { headers: { "User-Agent": "yourapp@example.com" } });
    const data = await response.json();
    if (data && data.length > 0) {
      return { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) };
    }
    return null;
  } catch (err) {
    console.error(`[getLatLon] Error:`, err);
    return null;
  }
}

function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 3958.8; // miles
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat/2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon/2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function resetModal() {
  document.getElementById("free-shipping-step-1").style.display = "block";
  const resultDiv = document.getElementById("geo-result");
  if (resultDiv) resultDiv.remove();
}

// --- MAIN GEO LOGIC ---
document.getElementById("run-geo").addEventListener("click", async function() {
  const province = document.getElementById("shipto-province").value;
  const zip = document.getElementById("shipto-zip").value.trim();
  const modalLogmat = document.getElementById("free-ship-modal").getAttribute("data-logmat");

  if (!zip) {
    alert("Please enter your ZIP code first.");
    return;
  }

  document.getElementById("free-shipping-step-1").style.display = "none";
  const modalContent = document.getElementById("free-ship-modal-content");
  let loadingHTML = document.createElement('div');
  loadingHTML.id = "geo-result";
  loadingHTML.innerHTML = `
    <div style="text-align:center; min-height: 300px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <div class="spinner"></div>
      <p style="margin-top: 1rem;">Checking eligibility...</p>
    </div>
  `;
  modalContent.appendChild(loadingHTML);

  if (province !== "Florida") {
    showNotEligible(modalLogmat);
    return;
  }

  const customerCoords = await getLatLon(zip);
  if (!customerCoords) {
    alert("Could not determine your location from ZIP code.");
    resetModal();
    return;
  }

  let bestDist = Infinity;
  let bestWarehouse = null;

  for (const wh of Object.values(window.shippingData)) {
    if (wh.state !== "Southeast" || !wh.logmats.includes(parseInt(modalLogmat))) continue;
    const whCoords = await getLatLon(wh.zip);
    if (!whCoords) continue;
    const dist = calculateDistance(customerCoords.lat, customerCoords.lon, whCoords.lat, whCoords.lon);
    if (dist < bestDist) {
      bestDist = dist;
      bestWarehouse = wh;
    }
  }

  if (bestDist <= 100 && bestWarehouse) {
    showEligible(modalLogmat, bestWarehouse);
  } else {
    showNotEligible(modalLogmat);
  }
});

// --- FUNCTIONS TO SHOW ELIGIBLE / NOT ELIGIBLE ---

function showEligible(logmatId, warehouse) {
  const modalContent = document.getElementById("geo-result");
  modalContent.innerHTML = `
  <div id="free-shipping-step-2" class="!w-full">
    <div class="w-full" style="display: flex; flex-direction: column; min-height: 300px;">
      

        
        <h2 style="text-align: center; border-bottom: 1px solid #ccc; text-transform: none; padding-top: .5rem; padding-bottom: .5rem;">
          Eligible for Free Shipping!
        </h2>
        
        <p style="text-align: center; padding: 2rem 1rem;">You got it! We provide free shipping depending on volume, weight, and proximity to our incredible logistics partners. We're excited to proceed with your order!</p>
      </div>

      <div style="display: flex; gap: 1rem; justify-content: flex-end; padding: 1rem;">
        <button id="ok-modal-btn" class="btn1 btn1-primary" style="width:100%; cursor:pointer;">OK</button>
      </div>

    </div>
  </div>
  `;
  document.getElementById("ok-modal-btn").addEventListener("click", function() {
  const modalLogmat = document.getElementById("free-ship-modal").getAttribute("data-logmat");
  const logmatGroup = document.querySelector(`.logmat-group[data-logmat="${modalLogmat}"]`);
  if (logmatGroup) {
    logmatGroup.setAttribute("data-free-shipping", "true");
    logmatGroup.setAttribute("data-free-shipping-eligible", "true");
    logmatGroup.setAttribute("data-free-shipping-denied", "false"); // clear any denied
  }

  toggleEligibilityDisplay();
  toggleFreeShippingBlocks();
  toggleChangeZipButton();

  document.getElementById("free-ship-modal").style.display = "none";
  resetModal();
});

}

function showNotEligible(logmatId) {
  const modalContent = document.getElementById("geo-result");
  modalContent.innerHTML = `
        <div id="free-shipping-step-2" class="!w-full">
    <div class="w-full" style="display: flex; flex-direction: column; justify-content: space-between; min-height: 300px;">
      
      <div class="w-full">


        
        <h2 style="text-align: center; border-bottom: 1px solid #ccc; text-transform: none; padding-top: .5rem; padding-bottom: .5rem;">
          Not Eligible for Free Shipping
        </h2>
        
        <p style="text-align: center; padding: 2rem 1rem;">No worries! You can still proceed with Batch Shipping or Request a Quote! Both options still come with a dedicated customer service representative ready to help you get the cheapest option possible.</p>
      </div>

      <div style="display: flex; gap: 1rem; justify-content: flex-end; padding: 1rem;">
      <button id="close-modal-btn" class="btn1 btn1-primary" style="width: 100%">Close</button>
      </div>
    </div>
  </div>
  `;
  document.getElementById("close-modal-btn").addEventListener("click", function() {
  const modalLogmat = document.getElementById("free-ship-modal").getAttribute("data-logmat");
  const logmatGroup = document.querySelector(`.logmat-group[data-logmat="${modalLogmat}"]`);
  if (logmatGroup) {
    logmatGroup.setAttribute("data-free-shipping-denied", "true");
  }

  toggleEligibilityDisplay();
  toggleFreeShippingBlocks();
  toggleChangeZipButton();

  document.getElementById("free-ship-modal").style.display = "none";
  resetModal();
});

}


document.getElementById("free-ship-close").addEventListener("click", function() {
  document.getElementById("free-ship-modal").style.display = "none";
  resetModal();
});

// --- SPINNER STYLES ---
const style = document.createElement('style');
style.innerHTML = `
  @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  .spinner { border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; }
`;
document.head.appendChild(style);

// --- UPDATE UI FUNCTION ---
function updateShippingDisplay() {
  if (typeof toggleEligibilityDisplay === "function") toggleEligibilityDisplay();
  if (typeof toggleFreeShippingBlocks === "function") toggleFreeShippingBlocks();
  if (typeof toggleChangeZipButton === "function") toggleChangeZipButton();
  if (typeof debouncedUpdateShippingOptionHeaders === "function") debouncedUpdateShippingOptionHeaders();
}
